import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import * as myGlobals from './../global';

@Injectable()
export class HttpErrorValidator {
  constructor(private auth: AuthService) {}

  /** Background loads (catalogs, lists): do not interrupt the user, just log it. */
  validateError(error: any) {
    if (this.handleSessionEnded(error)) {
      return;
    }

    console.error('Request failed: ' + this.getMessage(error), error);
  }

  /** User-initiated actions: the user is waiting on the result, so say what happened. */
  reportError(error: any, action: string) {
    if (this.handleSessionEnded(error)) {
      return;
    }

    console.error(action, error);
    alert(action + ': ' + this.getMessage(error));
  }

  /** The backend reason when there is one, never a raw stack. */
  getMessage(error: any): string {
    if (error == null) {
      return 'Error inesperado';
    }

    if (error.status === 0) {
      return 'No se pudo contactar al servidor';
    }

    const apiError = error.error != null ? error.error : null;

    if (apiError != null) {
      // 400 responses carry the failed field validations, the rest only a message.
      if (apiError.errors != null && apiError.errors.length > 0) {
        return apiError.errors.join(', ');
      }
      if (apiError.message) {
        return apiError.message;
      }
    }

    return 'Error ' + (error.status != null ? error.status : '') + ': la operación no se completó';
  }

  /** Ends the session only when the 401 really says the session token is gone. */
  private handleSessionEnded(error: any): boolean {
    if (!this.isSessionTokenRejected(error)) {
      return false;
    }

    alert('La sesión termino porque otro usuario se autenticó con sus credenciales');
    this.auth.logoutUser();
    return true;
  }

  /**
   * A 401 is only about our session when webadmin rejects the session token.
   * Other backends (comercios/Amex) answer 401 for their own reasons and never manage our session,
   * and webadmin itself uses 401 for permission checks too.
   */
  private isSessionTokenRejected(error: any): boolean {
    if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
      return false;
    }

    const webadminApi = myGlobals.baseApi.replace(/\/+$/, '');

    if (error.url != null && error.url.indexOf(webadminApi) !== 0) {
      return false;
    }

    const reason = error.error != null && error.error.message ? String(error.error.message) : '';

    // No reason at all: assume the session, since every webadmin call needs a valid token.
    return reason === '' || /token de sesi/i.test(reason);
  }
}
